export const IMPORT_SAVE_CSV_FILE_DATA = 'IMPORT_SAVE_CSV_FILE_DATA';
export const IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_BEGIN = 'IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_BEGIN';
export const IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_SUCCESS =
  'IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_SUCCESS';
export const IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_FAILURE =
  'IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_FAILURE';
export const IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_DISMISS_ERROR =
  'IMPORT_IMPORT_ITEMS_FROM_CSV_DATA_DISMISS_ERROR';
export const IMPORT_CLOSE_IMPORT_MAPPING = 'IMPORT_CLOSE_IMPORT_MAPPING';
